var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1473:15668",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1473:15668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    fill: "white",
    stroke: "#4F32CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99976 5.5C5.17133 5.5 4.49976 6.17157 4.49976 7V13C4.49976 13.2761 4.72361 13.5 4.99976 13.5H8.99976C9.2759 13.5 9.49976 13.2761 9.49976 13V6C9.49976 5.72386 9.2759 5.5 8.99976 5.5H5.99976Z",
    stroke: "#4F32CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 5.5H13.4995C12.9472 5.5 12.4995 5.94772 12.4995 6.5V12.5C12.4995 13.0523 12.9472 13.5 13.4995 13.5H16.4995C17.0518 13.5 17.4995 13.0523 17.4995 12.5V6.5C17.4995 5.94772 17.0518 5.5 16.4995 5.5Z",
    stroke: "#4F32CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 5.5C20.7237 5.5 20.4999 5.72386 20.4999 6V13C20.4999 13.2761 20.7237 13.5 20.9999 13.5H24.9999C25.276 13.5 25.4999 13.2761 25.4999 13V7C25.4999 6.17157 24.8283 5.5 23.9999 5.5H20.9999Z",
    stroke: "#4F32CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99963 16.5C4.72349 16.5 4.49963 16.7239 4.49963 17V23C4.49963 23.8284 5.17121 24.5 5.99963 24.5H8.99963C9.27578 24.5 9.49963 24.2761 9.49963 24V17C9.49963 16.7239 9.27578 16.5 8.99963 16.5H4.99963Z",
    stroke: "#4F32CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 16.5H13.4995C12.9472 16.5 12.4995 16.9477 12.4995 17.5V23.5C12.4995 24.0523 12.9472 24.5 13.4995 24.5H16.4995C17.0518 24.5 17.4995 24.0523 17.4995 23.5V17.5C17.4995 16.9477 17.0518 16.5 16.4995 16.5Z",
    stroke: "#4F32CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 16.5C20.7237 16.5 20.4999 16.7239 20.4999 17V24C20.4999 24.2761 20.7237 24.5 20.9999 24.5H23.9999C24.8283 24.5 25.4999 23.8284 25.4999 23V17C25.4999 16.7239 25.276 16.5 24.9999 16.5H20.9999Z",
    stroke: "#4F32CF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryIcon);
export default __webpack_public_path__ + "static/media/memory_icon.166a0b05d2f54d9654a3037345632f2d.svg";
export { ForwardRef as ReactComponent };